import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/cart',
    name: 'cart',
    component: () => import('@/views/cart.vue')
  },
  {
    path: '/confirmOrder',
    name: 'confirmOrder',
    component: () => import('@/views/confirmOrder.vue')
  },
  {
    path: '/productDetail/:code?',
    name: 'productDetail',
    component: () => import('@/views/productDetail.vue')
  },
  {
    path: '/search/:fruitKey?',
    name: 'search',
    component: () => import('@/views/exsearch.vue')
  },
  {
    path: '/classify/:fruitKey?',
    name: 'classify',
    component: () => import('@/views/classify.vue')
  },
  {
    path: '/advsearch',
    name: 'advsearch',
    component: () => import('@/views/advsearch.vue')
  },
  {
    path: '/coBrands',
    name: 'coBrands',
    component: () => import('@/views/coBrands.vue')
  },
  {
    path: '/productLineList',
    name: 'productLineList',
    component: () => import('@/views/productLineList.vue')
  },
  {
    path: '/productLineDetail',
    name: 'productLineDetail',
    component: () => import('@/views/productLineDetail.vue')
  },
  {
    path: '/coBrandsDetail',
    name: 'coBrandsDetail',
    component: () => import('@/views/coBrandsDetail.vue')
  },
  {
    path: '/hcProductDetail/:code?',
    name: 'hcProductDetail',
    component: () => import('@/views/hcProductDetail.vue')
  }, 
  {
    path: '/hcProductsDetail/:code?',
    name: 'hcProductsDetail',
    component: () => import('@/views/hcProductsDetail.vue')
  }, 
  {
    path: '/swProductDetail/:code?',
    name: 'swProductDetail',
    component: () => import('@/views/swProductDetail.vue')
  },
  {
    path: '/switemProductDetail/:code?',
    name: 'switemProductDetail',
    component: () => import('@/views/switemProductDetail.vue')
  },
  {
    path: '/html/:type?',
    name: 'html',
    component: () => import('@/views/html.vue')
  },
  {
    path: '/promotionProductList',
    name: 'promotionProductList',
    component: () => import('@/views/promotionProductList.vue')
  },
  {
    path: '/payment',
    name: 'payment',
    component: () => import('@/views/payment.vue')
  },
  {
    path: '/pay_ok',
    name: 'pay_ok',
    component: () => import('@/views/pay_ok.vue')
  },
  {
    path: '/pay_ok',
    name: 'pay_ok',
    component: () => import('@/views/pay_ok.vue')
  },
  {
    path: '/cancelOrder',
    name: 'cancelOrder',
    component: () => import('@/views/cancelOrder.vue')
  },
  {
    path: '/orderDetail',
    name: 'orderDetail',
    component: () => import('@/views/orderDetail.vue')
  },
  {
    path: '/pointsOrderDetail',
    name: 'pointsOrderDetail',
    component: () => import('@/views/pointsOrderDetail.vue') 
  },
  {
    path: '/user',
    name: 'user',
    component: () => import('@/views/user.vue')
  },

  {
    path: '/order_history',
    name: 'order_history',
    component: () => import('@/views/user.vue')
  },
  {
    path: '/profileInfo',
    name: 'profileInfo',
    component: () => import('@/views/user.vue')
  },
  {
    path: '/profileAddress',
    name: 'profileAddress',
    component: () => import('@/views/user.vue')
  },
  {
    path: '/profilePassword',
    name: 'profilePassword',
    component: () => import('@/views/user.vue')
  },
  {
    path: '/pointsMall',
    name: 'pointsMall',
    component: () => import('@/views/pointsMall.vue')
  },
  {
    path: '/pointsDetail',
    name: 'pointsDetail',
    component: () => import('@/views/pointsDetail.vue') 
  },
  {
    path: '/profile/add_address',
    name: 'add_address',
    component: () => import('@/views/user.vue')
  },
  {
    path: '/profile/edit_address/:addressId?',
    name: 'edit_address',
    component: () => import('@/views/user.vue')
  },

  // 支付管理开始
  {
    path: '/prepay',
    name: 'prepay',
    component: () => import('@/views/user.vue')
  },
  {
    path: '/credit',
    name: 'credit',
    component: () => import('@/views/user.vue')
  },
  {
    path: '/coupon',
    name: 'coupon',
    component: () => import('@/views/user.vue')
  },
  {
    path: '/integral',
    name: 'integral',
    component: () => import('@/views/user.vue')
  },
  {
    path: '/integralOrder',
    name: 'integralOrder',
    component: () => import('@/views/user.vue')
  },
    {
    path: '/bulk',
    name: 'bulk',
    component: () => import('@/views/bulk.vue')
  },
  {
    path: '/multiorder',
    name: 'multiorder',
    component: () => import('@/components/myorder/multiorder.vue') 
  },
  {
    path: '/forgot_password',
    name:'forgot_password',
    component: () => import('@/components/myorder/forgot_password.vue') 
  }
  // 支付管理结束
]

const router = createRouter({
  history: createWebHistory('/'), 
  routes
})

export default router
